import { ModelRegistry } from 'ember-data/model';
import DS, { ModelSchema } from 'ember-data';
import { IdentifierKey } from 'cio/utils/identifiers';
import ApplicationSerializer from './application';

const { EmbeddedRecordsMixin } = DS;

export default class CustomerSerializer extends ApplicationSerializer.extend(EmbeddedRecordsMixin, {
  isNewSerializerAPI: true,
  attrs: {
    devices: {
      serialize: false,
      deserialize: 'records',
    },
  },
}) {
  // Temporary: this will rename cid to cio_id while the back end is still
  // being worked on for multi-id work. It should become dead code once the
  // back end for multi-id goes out and can then be safely removed later.
  normalize(modelClass: ModelSchema<keyof ModelRegistry>, hash: Record<string, any>, prop?: string) {
    if (hash.identifiers.cid && !hash.identifiers[IdentifierKey.CioId]) {
      hash.identifiers[IdentifierKey.CioId] = hash.identifiers.cid;
      delete hash.identifiers.cid;
    }

    return super.normalize(modelClass, hash, prop);
  }

  serialize(snapshot: DS.Snapshot, options: Record<string, any>) {
    let json = super.serialize(snapshot, options) as Record<string, any>;
    let { record } = snapshot;
    let hiddenAttrs = (record as ModelRegistry['customer']).get('hiddenAttrs');

    // We want to set attributes to an empty string.
    // In the API an empty string is the same as deleting an attribute
    if (hiddenAttrs) {
      hiddenAttrs.forEach(function (item: string) {
        json.attributes[item] = '';
      });
    }

    return json;
  }
}
